import { useEffect } from "react";
import { setupIframeResizer } from "utilities/iframeResizer";

/**
 * Hook to handle iframe detection, CSS class management, and resizer setup
 * @param ready - Only setup iframe when initialization is complete
 */
export const useIframeSetup = (ready: boolean = true) => {
  useEffect(() => {
    if (!ready) return; // Don't setup until ready
    
    const isInIframe = window.parent !== window;
    
    if (isInIframe) {
      document.documentElement.classList.add("iframe-mode");
    }
    
    const cleanupResizer = setupIframeResizer();

    return () => {
      if (cleanupResizer) cleanupResizer();
      document.documentElement.classList.remove("iframe-mode");
    };
  }, [ready]);
};